import { forwardRef } from "react";
import * as TooltipPrimitive from "@radix-ui/react-tooltip";
import { cn } from "../../../lib/cn";

/**
 * Phase 2 — Radix Tooltip styled with our tokens. Replaces the ad-hoc
 * `.rs-bar-tip` and every `title=""` attribute that wanted a nicer
 * hover hint. Wrap a page (or the app) in <TooltipProvider> once and
 * use <Tooltip>/<TooltipTrigger>/<TooltipContent> anywhere below it.
 */
export const TooltipProvider = TooltipPrimitive.Provider;
export const Tooltip = TooltipPrimitive.Root;
export const TooltipTrigger = TooltipPrimitive.Trigger;

export const TooltipContent = forwardRef(function TooltipContent(
  { className, sideOffset = 6, ...props },
  ref,
) {
  return (
    <TooltipPrimitive.Content
      ref={ref}
      sideOffset={sideOffset}
      className={cn(
        "z-[1200] rounded-md border border-rc-border bg-[#070e20] text-rc-text-primary",
        "px-2.5 py-1.5 text-[11.5px] shadow-rc-md",
        "data-[state=delayed-open]:animate-fadeIn",
        className,
      )}
      {...props}
    />
  );
});
